import React from 'react';
import './footer.sass';
import Logo from '../../assets/Logo_footer.png';

export const Footer = () => {

    return(
        <div className='vv-landing-page-vendor-footer-container'>
            <div className='vv-landing-page-vendor-footer'>
                <img className='vv-landing-page-vendor-footer__logo' src={Logo}/>
            </div>
        </div>
    );
};